import axios from "axios";
import TokenService from "./token.service";

const baseURL = process.env.REACT_APP_API_URL;

const bilAPI = axios.create({
  baseURL,
  headers: {
    "Content-Type": "multipart/form-data",
    accept: "application/json",
  },
});

bilAPI.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

bilAPI.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error?.config || error?.response?.config;

    if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
      return Promise.reject(error);
    }

    if (error?.message === "Network Error" || error?.toJSON?.().message === "Network Error") {
      return Promise.reject(error);
    }

    if (!error?.response) {
      return Promise.reject(error);
    }

    const isLoginEndpoint = originalConfig?.url?.includes("/auth/login");
    const isRefreshEndpoint = originalConfig?.url?.includes("/auth/refresh/");

    if (isLoginEndpoint || isRefreshEndpoint || error.response.status !== 401 || originalConfig?._retry) {
      return Promise.reject(error);
    }

    const refreshToken = TokenService.getLocalRefreshToken();
    if (!refreshToken) {
      TokenService.removeTokens();
      window.dispatchEvent(new Event("session-expired"));
      return Promise.reject(error);
    }

    originalConfig._retry = true;

    try {
      const rs = await axios.post(`${baseURL}/auth/refresh/`, {
        refresh: refreshToken,
      });
      const token = rs.data.access;
      TokenService.updateLocalAccessToken(token);
      return bilAPI(originalConfig);
    } catch (refreshError) {
      TokenService.removeTokens();
      window.dispatchEvent(new Event("session-expired"));
      return Promise.reject(refreshError);
    }
  }
);

export default bilAPI;
